import React, { Component } from "react";
import { Button, Icon } from "@blueprintjs/core";
import { TASK_STATUS, TASK_STATUS_COLOR, PMDNDTypes } from "../../constants";
import IconSmallButton from "../../../blueprintWrappers/IconSmallButton";
import { DragSource } from 'react-dnd';

class PMTGSTask extends Component {

	state = {
		minimized: true,
		hover: false,
		expanded: true
	}

	render() {
		const p = this.props;
		return (
			<div className="PMTGSTask">
				{this.display()}
			</div>
		)
	}

	funcMinimize = () => {
		this.setState({
			minimized: !this.state.minimized
		})
	}

	display = () => {
		const { minimized } = this.state;
		return (
			<div>
				{this.header()}
				{!minimized ? this.body() : this.bodyClosed()}
				{/* TODO needs major changes this.footer()*/}
			</div>
		)
	}

	header = () => {
		const p = this.props;

		const statusStyle = {
			backgroundImage: 'linear-gradient(to right, ' + p.color + ', white)',
		}

		return p.connectDragSource(
			<div className="PMWindowHeader"
				onDoubleClick={this.funcMinimize}
				onMouseEnter={() => this.setState({ hover: true })}
				onMouseLeave={() => this.setState({ hover: false })}>

				{this.state.hover ?

					<div>
						<div className="PMWindowHeaderLeft">
							{p.task.display}
						</div>
						<div className="PMWindowHeaderRight">
							<IconSmallButton iconName={this.state.minimized ? "maximize" : "minimize"} onClick={this.funcMinimize} />
							<IconSmallButton iconName={'edit'} onClick={() => p.selectEditTask(p.task)} />
							<div className="PMStatusRound" style={statusStyle} />
						</div>
					</div>

					: /* else */

					<div>
						<div className="PMWindowHeaderLeft">
							{p.task.display}
						</div>
						<div className="PMWindowHeaderRight">
							<div className="PMStatusRound" style={statusStyle} />
						</div>
					</div>

				}
			</div>
		)
	}

	body() {
		const p = this.props;
		return (
			<div className={" pm-uncollapse"}  >
				{p.task.description}
				{this.state.expanded ? this.expanded() : null}
				{p.children}
			</div>
		)
	}

	bodyClosed() {
		const p = this.props;
		return (
			<div className={" pm-uncollapse"} onDoubleClick={this.funcMinimize} >
				{p.task.description}
			</div>
		)
	}

	expanded = () => {
		const p = this.props;
		return <div className="projectmanager_task_list_row_expanded" >

			<div className="projectmanager_task_list_row_item">
				<div>
					<b>General Notes</b>
					{p.task.generalNotes}
				</div>
				<div>
					<b>Dev Notes</b>
					{p.task.devNotes}
				</div>
				<div>
					<b>Lead Notes</b>
					{p.task.leadNotes}
				</div>

			</div>

			{this.subtasks()}
		</div>
	}

	subtasks() {
		const p = this.props;
		return (
			<div >
				subtasks
			</div>
		)
	}

	footer() { 
		// TODO make comments work with storedCommentLines
		// TODO make hours work with storedHourLines
		const p = this.props;
		const { hourLines } = p.task;
		return (
			<div className={"PMTaskFooter"}>
				<div className={"PMTaskGroupLine"}></div>
				<Icon icon="comment" /> { '1' /* p.task.comments.length*/}
				Hours: <b>{calcHoursWorked(hourLines)}</b> ({calcHoursBillable(hourLines)} planned)
				<b>{p.task.status}</b>
			</div>
		)

		function calcHoursWorked(hourLines) {
			let total = 0;
			for (let hl of hourLines) {
				total += parseFloat(hl.hours);
			}
			return total;
		}
		function calcHoursBillable(hourLines) {
			let total = 0;
			for (let hl of hourLines) {
				total += parseFloat(hl.billable);
			}
			return total;
		}
	}




}

const dragSource = {
	beginDrag: function (props, monitor, component) {
		//console.log("beginDrag");
		return props
	},
	isDragging: function (props, monitor, component) {
		//console.log("dragging");
	},
	endDrag: function (props, monitor, component) {
		//console.log("endDrag")
	}
}

function dragCollect(connect, monitor, component) {
	return {
		connectDragSource: connect.dragSource(),
		connectDragPreview: connect.dragPreview(),
		isDragging: monitor.isDragging(),
	}
}

PMTGSTask = DragSource(PMDNDTypes.WINDOW, dragSource, dragCollect)(PMTGSTask);
export default PMTGSTask;



// WEBPACK FOOTER //
// ./src/components/projectmanager/new/TaskGroup/PMTGSTask.js